export const messages = {
  en: {
    gold: {
      title: 'Community Gold',
      withdraw: 'Withdraw',
      transactionDetails: 'Transaction Details',
      goldWithdrawal: 'Gold Withdrawal'
    },
    goldInfo: {
      accountId: 'Account ID:',
      accountName: 'Account Name:',
      accountBalance: 'Account Balance:',
      communityName: 'Community Name:'
    },
    goldDetail: {
      id: 'ID',
      goldAccount: 'Gold Account',
      type: 'Type',
      transferIn: 'Transfer In',
      transferOut: 'Transfer Out',
      communityName: 'Community Name',
      communityId: 'Community ID',
      transactionAmount: 'Transaction Amount',
      currentAmount: 'Current Amount',
      transactionNo: 'Transaction No',
      remark: 'Remark',
      time: 'Time'
    },
    applyWithholdGold: {
      id: 'ID',
      goldId: 'Gold ID',
      accountName: 'Account Name',
      communityId: 'Community ID',
      withdrawAmount: 'Withdraw Amount',
      applicant: 'Applicant',
      applicantPhone: 'Applicant Phone',
      bankAccount: 'Bank Account',
      bankName: 'Bank Name',
      applicationNote: 'Application Note',
      status: 'Status',
      reviewNote: 'Review Note'
    },
    deleteApplyWithholdGold: {
      confirmTitle: 'Confirm Operation',
      confirmText: 'Are you sure to delete this gold withdrawal application?',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed'
    },
    withholdGold: {
      applyWithdraw: 'Apply Withdraw',
      goldAmount: 'Gold Amount',
      withdrawAmount: 'Withdraw Amount',
      applicant: 'Applicant',
      applicantPhone: 'Applicant Phone',
      bankAccount: 'Bank Account',
      accountName: 'Account Name',
      bankName: 'Bank Name',
      applicationNote: 'Application Note',
      required: 'Required',
      submitSuccess: 'Submit successfully',
      submitFailed: 'Submit failed'
    }
  },
  zh: {
    gold: {
      title: '小区金币',
      withdraw: '提现',
      transactionDetails: '交易明细',
      goldWithdrawal: '金币提现'
    },
    goldInfo: {
      accountId: '账户ID：',
      accountName: '账户名称：',
      accountBalance: '账户余额：',
      communityName: '小区名称：'
    },
    goldDetail: {
      id: '编号',
      goldAccount: '金币账户',
      type: '类型',
      transferIn: '转入',
      transferOut: '转出',
      communityName: '小区名称',
      communityId: '小区编号',
      transactionAmount: '交易金额',
      currentAmount: '当前金额',
      transactionNo: '交易单号',
      remark: '备注',
      time: '时间'
    },
    applyWithholdGold: {
      id: '编号',
      goldId: '金币ID',
      accountName: '账户名称',
      communityId: '小区编号',
      withdrawAmount: '提现金额',
      applicant: '申请人',
      applicantPhone: '申请人电话',
      bankAccount: '银行账户',
      bankName: '开户行',
      applicationNote: '申请说明',
      status: '状态',
      reviewNote: '审核说明'
    },
    deleteApplyWithholdGold: {
      confirmTitle: '请确认您的操作!',
      confirmText: '确定删除金币提现',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    },
    withholdGold: {
      applyWithdraw: '申请提现',
      goldAmount: '金币金额',
      withdrawAmount: '提现金额',
      applicant: '申请人',
      applicantPhone: '申请人电话',
      bankAccount: '银行账户',
      accountName: '账号名称',
      bankName: '开户行',
      applicationNote: '申请说明',
      required: '必填',
submitSuccess: '提交成功',
      submitFailed: '提交失敗'
    }
  },
  'zh-TW': {
    gold: {
      title: '小區金幣',
      withdraw: '提現',
      transactionDetails: '交易明細',
      goldWithdrawal: '金幣提現'
    },
    goldInfo: {
      accountId: '帳戶ID：',
      accountName: '帳戶名稱：',
      accountBalance: '帳戶餘額：',
      communityName: '小區名稱：'
    },
    goldDetail: {
      id: '編號',
      goldAccount: '金幣帳戶',
      type: '類型',
      transferIn: '轉入',
      transferOut: '轉出',
      communityName: '小區名稱',
      communityId: '小區編號',
      transactionAmount: '交易金額',
      currentAmount: '當前金額',
      transactionNo: '交易單號',
      remark: '備註',
      time: '時間'
    },
    applyWithholdGold: {
      id: '編號',
      goldId: '金幣ID',
      accountName: '帳戶名稱',
      communityId: '小區編號',
      withdrawAmount: '提現金額',
      applicant: '申請人',
      applicantPhone: '申請人電話',
      bankAccount: '銀行帳戶',
      bankName: '開戶行',
      applicationNote: '申請說明',
      status: '狀態',
      reviewNote: '審核說明'
    },
    deleteApplyWithholdGold: {
      confirmTitle: '請確認您的操作!',
      confirmText: '確定刪除金幣提現',
      deleteSuccess: '刪除成功',
      deleteFailed: '刪除失敗'
    },
    withholdGold: {
      applyWithdraw: '申請提現',
      goldAmount: '金幣金額',
      withdrawAmount: '提現金額',
      applicant: '申請人',
      applicantPhone: '申請人電話',
      bankAccount: '銀行帳戶',
      accountName: '帳號名稱',
      bankName: '開戶行',
      applicationNote: '申請說明',
      required: '必填',
      submitSuccess: '提交成功',
      submitFailed: '提交失敗'
    }
  }
}